var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6c0 .414.336.75.75.75h4.375c.069 0 .125.056.125.125v4.375c0 .414.336.75.75.75s.75-.336.75-.75V6.875c0-.069.056-.125.125-.125h4.375c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H6.875c-.069 0-.125-.056-.125-.125V.75C6.75.336 6.414 0 6 0s-.75.336-.75.75v4.375c0 .069-.056.125-.125.125H.75C.336 5.25 0 5.586 0 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.f08619062495c396e84f276bdbe7759d.svg";
export { ForwardRef as ReactComponent };